export const getWebsiteCurrency = (state) => {
  const {
    appGlobal: {
      currency: { currency },
    },
  } = state;
  return currency;
};
